import React, {useEffect, useRef, useState} from 'react';
import {useRecoilState} from "recoil";
import {loadingAtom} from "../atoms";
import Config from "../core/config";
import Cookies from "js-cookie";
import {formatPhoneNumber} from "../core/telephone";
import {validateEmail} from "../core/email";
import {formatCPF, validateCPF} from "../core/cpf";
import {isOver} from "../core/date";
import {useNavigate} from "react-router-dom";

import {formatLocalDate, parseLocalDate} from "../utils/utils";
import DateSelector from "./DateSelector";
import { showConfirm, showAlert } from '../core/dialog';
const CustomerAutoFilling_Documents = (props, {onCustomerAdded}) => {
    const navigate = useNavigate();
    const customerKey = Cookies.get('customerKey');
    const companyImg = Cookies.get('selfRegistrationImagePath') || null;
    const [customerKeyValid, setCustomerKeyValid] = useState(false);
    const currentCustomerAutoFilling = Cookies.get('customerAutoFilling');

    const inputTextRg = useRef();
    const inputTextCpf = useRef();
    const inputTextBirthDateDay = useRef();
    const inputTextBirthDateMonth = useRef();
    const inputTextBirthDateYear = useRef();


    const newEntity = {
        id: undefined,
        name: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        phone: '',
        email: '',
        instagram: '@',
        birthDate: undefined,
        rg: '',
        cpf: '',
        delivery: false,
        spaceBorneDelivery: false,
        howDidYouFindUs: '',
        referral: ''
    };


    const [formData, setFormData] = useState(currentCustomerAutoFilling ? JSON.parse(currentCustomerAutoFilling) : newEntity);

    useEffect(() => {
        // Validate customer key
        if (customerKey) {
            setCustomerKeyValid(true);
        } else {
            setCustomerKeyValid(false);
            navigate(`/autocadastro/linkInvalido`);
            return;
        }
        
        if(inputTextRg.current) {
            inputTextRg.current.focus();
        }
    }, [customerKey, navigate])

    const handleBirthDateChange = (dateStr) => {
        setFormData((prevData) => ({
            ...prevData,
            birthDate: dateStr
        }));
    };
    const handleSaveButtonClick = async () => {

        try {
            if (validateInputs()) {
                await save();
            }
        } catch (error) {
            console.error('Error saving:', error);
            showAlert('Error ao salvar.');
        }
    };

    function validateInputs() {

        if (!formData.rg || formData.rg === '') {
            showAlert('Preencha o campo RG.');
            if (inputTextRg.current) {
                inputTextRg.current.focus();
            }
            return false;
        }

        if (!formData.cpfCnpj || formData.cpfCnpj === '') {
            showAlert('Preencha o campo cpf.');
            if (inputTextCpf.current) {
                inputTextCpf.current.focus();
            }
            return false;
        }

        if (!validateCPF(formData.cpfCnpj)) {
            showAlert('CPF inválido.');
            if (inputTextCpf.current) {
                inputTextCpf.current.focus();
            }
            return false;
        }

        if (!formData.birthDate || formData.birthDate === '') {
            showAlert('Preencha o campo data de nascimento.');
            if (inputTextBirthDateDay.current) {
                inputTextBirthDateDay.current.focus();
            }
            return false;
        }

        if (!isOver(parseLocalDate(formData.birthDate), 18)) {
            showAlert('Data de nascimento inválida. Menor de 18 anos.');
            if (inputTextBirthDateDay.current) {
                inputTextBirthDateDay.current.focus();
            }
            return false;
        }

        if (isOver(parseLocalDate(formData.birthDate), 100)) {
            showAlert('Data de nascimento inválida. Data muito antiga.');
            if (inputTextBirthDateDay.current) {
                inputTextBirthDateDay.current.focus();
            }
            return false;
        }

        return true;
    }

    async function save() {
        const dataToSave = {
            ...formData,
            customerKey: formData.customerKey || customerKey,
        };
        Cookies.set('customerAutoFilling', JSON.stringify(dataToSave));
        navigate('/autocadastro/endereco');
    }


    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    function handleBackButtonClick() {
        const key = Cookies.get('customerKey');
        if (key) {
            navigate(`/autocadastro/${key}`);
        } else {
            navigate(`/autocadastro/linkInvalido`);
        }
    }

    return (
        <div>

                {companyImg && <div style={{textAlign: 'center'}}><img src={companyImg} alt="Logo" style={{maxHeight: '120px', width: 'auto'}}/></div>}
            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>RG:</div>
                <input ref={inputTextRg} type="text" style={{width: '300px'}} id="rg" value={formData.rg} name="rg" onChange={handleChange}/>
            </div>

            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>CPF:</div>
                <input ref={inputTextCpf} type="text" style={{width: '300px'}} id="cpfCnpj" value={formData.cpfCnpj} name="cpfCnpj" maxLength="14"
                       onChange={(e) => {
                           e.target.value = formatCPF(e.target.value);
                           handleChange(e);
                       }}/>
            </div>

            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Nascimento:</div>
                <DateSelector
                    value={formData.birthDate}
                    onChange={handleBirthDateChange}
                    dayRef={inputTextBirthDateDay}
                    monthRef={inputTextBirthDateMonth}
                    yearRef={inputTextBirthDateYear}
                    maxYear={new Date().getFullYear() - 18}
                />
            </div>


            <div style={{marginTop: '10px', display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
                <button onClick={handleBackButtonClick} style={{opacity: 0.5, padding: '10px 24px', width: '120px'}}>Voltar</button>
                <button onClick={handleSaveButtonClick} style={{fontWeight: 'bold', padding: '10px 24px', width: '120px'}}>Continuar</button>
            </div>


        </div>
    );
};

export default CustomerAutoFilling_Documents; 